<template></template>

<script>
export default {
  mounted() {
    this.$store.dispatch('auth/selectOrganization', { value: this.$route.params.id }).then(() => {
      if (this.$route.query.page) {
        this.$router.push({ name: this.$route.query.page, params: { organizationId: this.$route.params.id } })
      } else {
        this.$router.push({ name: 'home', params: { organizationId: this.$route.params.id } })
      }
    })
  },
}
</script>
